import script from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./AppTooltip.vue?vue&type=style&index=0&id=265192fd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265192fd"]])

export default __exports__